/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {RequestMethod} from './enums';
/**
 * @param {?} method
 * @return {?}
 */
export function normalizeMethodName(method: string | RequestMethod): RequestMethod {
  if (typeof method !== 'string') return method;

  switch (method.toUpperCase()) {
    case 'GET':
      return RequestMethod.Get;
    case 'POST':
      return RequestMethod.Post;
    case 'PUT':
      return RequestMethod.Put;
    case 'DELETE':
      return RequestMethod.Delete;
    case 'OPTIONS':
      return RequestMethod.Options;
    case 'HEAD':
      return RequestMethod.Head;
    case 'PATCH':
      return RequestMethod.Patch;
  }
  throw new Error(`Invalid request method. The method "${method}" is not supported.`);
}

export const /** @type {?} */ isSuccess = (status: number): boolean => (status >= 200 && status < 300);
/**
 * @param {?} xhr
 * @return {?}
 */
export function getResponseURL(xhr: any): string {
  if ('responseURL' in xhr) {
    return xhr.responseURL;
  }
  if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
    return xhr.getResponseHeader('X-Request-URL');
  }
  return;
}
/**
 * @param {?} input
 * @return {?}
 */
export function stringToArrayBuffer(input: String): ArrayBuffer {
  const /** @type {?} */ view = new Uint16Array(input.length);
  for (let /** @type {?} */ i = 0, /** @type {?} */ strLen = input.length; i < strLen; i++) {
    view[i] = input.charCodeAt(i);
  }
  return view.buffer;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
